import { SELECT_DYNAMIC_AGENT } from './typeConstants';

export const selectDynamicAgent = (data) => ({
    type: SELECT_DYNAMIC_AGENT,
    data,
});
